export const BuildUrl = (path: string) => {
	const CONSULT_BASE_URL = process.env.REACT_APP_CONSULTS_URL;
	return `${CONSULT_BASE_URL ? CONSULT_BASE_URL : ""}${path}`;
};
